import { render, staticRenderFns } from "./ViewComment.vue?vue&type=template&id=d33f1060&scoped=true"
import script from "./ViewComment.vue?vue&type=script&lang=js"
export * from "./ViewComment.vue?vue&type=script&lang=js"
import style0 from "./ViewComment.vue?vue&type=style&index=0&id=d33f1060&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d33f1060",
  null
  
)

export default component.exports